import React from 'react';

const Logo = ({ className = "w-8 h-8", color = "currentColor", showText = false }) => {
  return (
    <svg 
      className={className} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Heart Shape */}
      <path 
        d="M50 85C50 85 15 55 15 35C15 25 25 15 35 15C40 15 45 17.5 50 22.5C55 17.5 60 15 65 15C75 15 85 25 85 35C85 55 50 85 50 85Z" 
        stroke={color} 
        strokeWidth="3" 
        fill="none"
      />
      
      {/* Camera Lens/Aperture */}
      <circle 
        cx="50" 
        cy="45" 
        r="12" 
        fill={color}
      />
      <path 
        d="M50 33C50 33 50 33 50 33M50 57C50 57 50 57 50 57M38 45C38 45 38 45 38 45M62 45C62 45 62 45 62 45M44 38C44 38 44 38 44 38M56 52C56 52 56 52 56 52M56 38C56 38 56 38 56 38M44 52C44 52 44 52 44 52" 
        stroke="white" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
      
      {/* Viewfinder/Button */}
      <ellipse 
        cx="65" 
        cy="30" 
        rx="4" 
        ry="2.5" 
        fill={color}
      />
      
      {/* Hot Shoe/Flash Mount */}
      <rect 
        x="47" 
        y="8" 
        width="6" 
        height="3" 
        rx="1.5" 
        fill={color}
      />
      
      {/* Text - Visions of Love */}
      {showText && (
        <text 
          x="20" 
          y="75" 
          fontSize="8" 
          fill={color} 
          fontFamily="serif" 
          fontStyle="italic"
          transform="rotate(-15 20 75)"
        >
          Visions of Love
        </text>
      )}
      
      {/* Text - By Tammy Diaz */}
      {showText && (
        <text 
          x="80" 
          y="75" 
          fontSize="6" 
          fill={color} 
          fontFamily="serif" 
          fontStyle="italic"
          transform="rotate(15 80 75)"
        >
          By Tammy Diaz
        </text>
      )}
    </svg>
  );
};

export default Logo;
